import { useDispatch, useSelector } from 'react-redux'
import SelectBox from 'components/form/SelectBox'
import { selectKeyword } from 'features/editlog/editlogSlice'
import { isEmpty } from 'utils'

const KeywordFilter = () => {
  const dispatch = useDispatch()
  const { keywords, selectedGroup, selectedKeyword, isLoading } = useSelector(
    state => state.editlog
  )

  return (
    <SelectBox
      placeholder="키워드 선택"
      value={selectedKeyword}
      onValueChange={v => dispatch(selectKeyword(v))}
      disabled={!selectedGroup || isEmpty(keywords) || isLoading}>
      {keywords.map(keyword => (
        <SelectBox.Item key={keyword.id} value={keyword}>
          {keyword.text} {keyword.deletedDate && '(삭제)'}
        </SelectBox.Item>
      ))}
    </SelectBox>
  )
}

export default KeywordFilter

KeywordFilter.propTypes = {}
